import React from 'react';
import { Moon, Sun, HelpCircle } from 'lucide-react';
import LanguageDropdown from './LanguageDropdown';

const Header = ({
    title,
    subtitle,
    darkMode,
    toggleDarkMode,
    language,
    setLanguage,
    showLanguageDropdown,
    setShowLanguageDropdown,
    onShowHowToPlay
}) => {
    return (
        <header className="mb-8 flex items-start justify-between py-2">
            <div className="leading-none">
                <span className="mb-1 block text-[9px] font-semibold uppercase tracking-[0.34em] text-spy-muted">
                    The
                </span>
                <h1 className="font-display text-[25px] font-semibold leading-none tracking-[0.01em] text-spy-text">
                    {title}<span className="text-spy-primary">.</span>
                </h1>
                <p className="mt-3 max-w-[18rem] text-[13px] leading-relaxed text-spy-muted">
                    {subtitle}
                </p>
            </div>

            <div className="flex items-center gap-[9px]">
                <div className="flex items-center gap-[9px]">
                    <LanguageDropdown
                        language={language}
                        setLanguage={setLanguage}
                        showLanguageDropdown={showLanguageDropdown}
                        setShowLanguageDropdown={setShowLanguageDropdown}
                    />
                    <button
                        onClick={onShowHowToPlay}
                        aria-label="How to play"
                        className="grid h-[38px] w-[38px] place-items-center rounded-full border border-spy-border2 bg-transparent text-spy-soft hover:border-spy-primary hover:text-spy-primary"
                    >
                        <HelpCircle className="h-[18px] w-[18px]" />
                    </button>
                </div>

                <button
                    onClick={toggleDarkMode}
                    aria-label={darkMode ? 'Use lighter contrast' : 'Use darker contrast'}
                    className="grid h-[38px] w-[38px] place-items-center rounded-full border border-spy-border2 bg-transparent text-spy-soft hover:border-spy-primary hover:text-spy-primary"
                >
                    {darkMode ? (
                        <Sun className="h-[18px] w-[18px]" />
                    ) : (
                        <Moon className="h-[18px] w-[18px]" />
                    )}
                </button>
            </div>
        </header>
    );
};

export default Header;
